var truncateString = function truncateString() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    string = _ref.string,
    _ref$length = _ref.length,
    length = _ref$length === void 0 ? 25 : _ref$length;
  if (string.length > length) return string.slice(0, length).concat('...');
  return string;
};
export default truncateString;